import React, { useState, useEffect, useRef } from "react";
import "./AgriInvoices.css";
import logo from "../../../Assets/jklogo.png";
import logo1 from "../../../Assets/jk.png"
import Sign from "../../../Assets/DirectorSign.png";
import Sign1 from "../../../Assets/DirectorSign1.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import QRCode from "qrcode";
import PdfPreview from "../../../Common/PDFPreview";
import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";
import PrintButton from "../../../Common/Buttons/PrintPDF";
import HeaderJK from "../../../Assets/HeaderJK.png";
import FooterJK from "../../../Assets/FooterJK.png";
import FooterJK1 from "../../../Assets/FooterJK1.png";
import "../../../Common/Fonts/Signika-Bold-normal";
import "../../../Common/Fonts/Signika-Regular-normal";
import "../../../Common/Fonts/Signika-Medium-normal";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";

const API_URL = process.env.REACT_APP_API;

const AgriSaleBillReport = ({ doc_no, disabledFeild }) => {
  const companyCode = sessionStorage.getItem("Company_Code");
  const Year_Code = sessionStorage.getItem("Year_Code");
  const [invoiceData, setInvoiceData] = useState([]);
  const [pdfPreview, setPdfPreview] = useState(null);
  const TCSApplicable = sessionStorage.getItem("TCSApplicable");
  const CompanyNameUpdatedDate = sessionStorage.getItem("CompanyNameUpdatedDate")
  const newCompanyName = sessionStorage.getItem("newCompanyName")
  const oldFormerlyName = sessionStorage.getItem("oldFormerlyName")

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${API_URL}/generating_AgroSale_report?Company_Code=${companyCode}&Year_Code=${Year_Code}&doc_no=${doc_no}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      setInvoiceData(data.all_data);
      generatePdf(data.all_data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const generatePdf = async (data) => {

    if (!data || data.length === 0) return;

    const items = Array.isArray(data) ? data : [data];
    const header = items[0];
    const pdf = new jsPDF({ orientation: "landscape" });

    const docDate = new Date(header.Doc_Date);
    const cnameUpdatedDate = new Date(CompanyNameUpdatedDate);

    const displayCompanyName =
      docDate < cnameUpdatedDate
        ? newCompanyName
        : header.Company_Name_E;

    const logoToUse = docDate < cnameUpdatedDate ? logo : logo1;
    const SignToUse = docDate < cnameUpdatedDate ? Sign1 : Sign;
    const foormerlyName = docDate < cnameUpdatedDate ? oldFormerlyName : header.AL1;

    pdf.setFont("Signika-Regular");
    pdf.setFontSize(8);

    const logoImg = new Image();
    const signImg = new Image();
    const headerImg = new Image();
    const footerImg = new Image();
    const footerImg1 = new Image();
    logoImg.src = logo;
    signImg.src = SignToUse;
    headerImg.src = HeaderJK;
    footerImg.src = FooterJK;
    footerImg1.src = FooterJK1

    const qrCodeData = `
    GSTN of Supplier : ${header.companyGSTno || ""}
    GSTIN of Buyer : ${header.billtogstno || ""}
    Document No. : ${header.Doc_No || ""}
    Document Type : Tax Invoice
    Date : ${header.doc_dateConverted || ""}
    HSN : ${header.HSN || ""}
    IRN : ${header.einvoiceno || ""}
    `;
    const qrCodeDataUrl = await QRCode.toDataURL(qrCodeData.trim());

    logoImg.src = logoToUse;
    logoImg.onload = () => {

      const shouldUseImage =
        docDate >= cnameUpdatedDate

      if (shouldUseImage) {
        // Use header image across top (new template)
        pdf.addImage(headerImg, "PNG", 0, 6, 180, 34); // full width
      } else {
        // Old layout: logo + company name + address lines
        pdf.addImage(logoImg, "PNG", 10, 9, 30, 30);
        pdf.setFont("Signika-Bold");
        pdf.setFontSize(14);
        pdf.text(displayCompanyName, 50, 14);
        pdf.setFont("Signika-Regular");
        pdf.setFontSize(9);
        pdf.text(`${foormerlyName}`, 50, 18);
        pdf.text(`${header.AL2}`, 50, 22);
        pdf.text(`${header.AL3}`, 50, 26);
        pdf.text(`${header.AL4}`, 50, 30);
        pdf.text(`${header.Other}`, 50, 34);
        pdf.text(`${header.BillFooter}`, 50, 38);
      }
      pdf.addImage(qrCodeDataUrl, "PNG", 230, 9, 30, 30);

      pdf.setFontSize(10);
      pdf.setFont("Signika-Bold");
      pdf.setDrawColor(80, 80, 80);
      pdf.line(10, 44, 280, 44);
      pdf.setTextColor(41, 122, 14);
      pdf.text("TAX INVOICE", 130, 49);
      pdf.setLineWidth(0.3);
      pdf.setDrawColor(80, 80, 80);
      pdf.line(10, 52, 280, 52);
      pdf.setTextColor(0, 0, 0);

      let y = 45;
      pdf.setFontSize(9);
      const fssaiNo = header.billtofssaie;

      const tanNo = header.billtoTanno;

      const billToLines = [
        header.billtoname,

        `${header.billtoaddress}, ${header.billtostatename} ${header.billtopincode}`,

        `City: ${`${header.billtopin} (${header.billtostatename} - ${header.billtogststatecode})`
        }`,
        `GST: ${header.billtogstno
        }`,

        `PAN: ${header.billtopan
        }`,

        fssaiNo ? `FSSAI: ${fssaiNo}` : null,
        tanNo ? `TAN: ${tanNo}` : null,
        
        
        
      ].filter(Boolean)

     const fieldPairs = [
  [
    `Invoice No: AS${header.year}-${header.Doc_No}`,
    `Transport Mode: Road`,
  ],
  [
    `Invoice Date: ${header.doc_dateConverted}`,
    `DO No: ${header.purcno}`,
  ],
  [
    `Date of Supply: ${header.doc_dateConverted}`,
    `Place Of Supply: ${header.billtopin}`,
  ],
  [
    `From: ${header.godawnname}`,
    `Ref By: ${header.brokername || ""}`,
  ],
  [
     `E-Invoice No.: ${header.einvoiceno}`,
     `Acknowledge: ${header.ackno}`
    ],
  
  [`E-Way Bill No.: ${header.EWay_Bill_No}`,
     `EwayBill ValidDate: ${header.EwayBillValidDate}`],
];

      const sectionStartY = y + 15;

      let leftY = sectionStartY;
      let rightY = sectionStartY;

      const leftX = 10;
      const rightX = 120;   // adjust if needed
      const wrapWidth = 80;
      let lineHeight = 4;

      pdf.setFont("Signika-Medium");
      pdf.text("Buyer (Bill To):", leftX, leftY);
      leftY += 6;

      pdf.setFont("Signika-Regular");

      billToLines.forEach((line) => {
        const lines = pdf.splitTextToSize(line, wrapWidth);
        lines.forEach((l) => {
          pdf.text(l, leftX, leftY);
          leftY += lineHeight;
        });
      });

      const leftLabelX = rightX;
      const leftValueX = rightX + 35;

      const rightLabelX = rightX + 70;
      const rightValueX = rightX + 100;
     let col1X = 120;   // Left column start
      let col2X = 200;   // Right column start
     lineHeight = 6;

fieldPairs.forEach(([leftText, rightText]) => {

  // LEFT COLUMN
  if (leftText) {
    const lines = pdf.splitTextToSize(leftText, 70);
    lines.forEach((line, i) => {
      pdf.text(line, col1X, rightY + i * 4);
    });
  }

  // RIGHT COLUMN
  if (rightText) {
    const lines = pdf.splitTextToSize(rightText, 70);
    lines.forEach((line, i) => {
      pdf.text(line, col2X, rightY + i * 4);
    });
  }

  rightY += lineHeight;
});

      const bottomY = Math.max(leftY, rightY) ;

      pdf.setDrawColor(80, 80, 80);
      pdf.setLineWidth(0.3);

      // Bottom border
      pdf.line(10, bottomY, 280, bottomY);

      // Vertical divider
      pdf.line(110, sectionStartY - 8, 110, bottomY);

      y = bottomY + 5;

      pdf.setDrawColor(80, 80, 80);
      pdf.setLineWidth(0.3);
      pdf.setDrawColor(80, 80, 80);


      pdf.setFont("Signika-Medium");
      pdf.setTextColor(41, 122, 14);
      pdf.text("Particulars", 12, y);
      pdf.text("HSN", 70, y);
      pdf.text("Bags", 50, y, { align: "left" });

      pdf.text("Quintal", 90, y, { align: "left" });
      pdf.text("Rate", 110, y);
      pdf.text("Value", 140, y, { align: "right" });
      pdf.text("CGST%", 160, y, { align: "right" });
      pdf.text("CGSTAmt", 180, y, { align: "right" });
      pdf.text("SGST%", 200, y, { align: "right" });
      pdf.text("SGSTAmt", 220, y, { align: "right" });
      pdf.text("IGST%", 240, y, { align: "right" });
      pdf.text("IGSTAmt", 260, y, { align: "right" });
      pdf.text("ToalAmt", 280, y, { align: "right" });


      y += 5;

      pdf.setLineWidth(0.3);
      pdf.setDrawColor(80, 80, 80);
      pdf.line(10, y, 280, y);
      y += 5;
      let rate = 0;
      const amountX = 200;
      const rateX = 170;
      const labelX = 140;

      let grandTaxable = 0;

      items.forEach((item) => {

        if (y > 270) {
          pdf.addPage();
          y = 15;
        }

        const qty = parseFloat(item.Quintal || 0);
        const value = parseFloat(item.Value || 0);
        const rate = qty > 0 ? value / qty : 0;

        grandTaxable += value;

        pdf.setFont("Signika-Regular");

        pdf.text(String(item.itemname || "Sugar"), 12, y);
        pdf.text(String(item.HSN || ""), 70, y);
        pdf.text(String(item.Bags || ""), 50, y);

        pdf.text(
          qty.toLocaleString("en-IN", { minimumFractionDigits: 2 }),
          90,
          y
        );

        pdf.text(
          rate.toLocaleString("en-IN", { minimumFractionDigits: 2 }),
          120,
          y,
          { align: "right" }
        );

        pdf.text(
          value.toLocaleString("en-IN", { minimumFractionDigits: 2 }),
          140,
          y,
          { align: "right" }
        );
        let halfGst=0;
        
        let igstAmt = parseFloat(item.IGST) || 0;
        //let gstAmt = parseFloat(item.gstarte) || 0;

        //let displayGST = 0;

        // if (igstAmt > 0) {
        //   halfGst = (parseFloat(item.gstarte) || 0) ;
        // } else {
        //   halfGst = (parseFloat(item.gstarte) || 0) / 2;
        // }

        pdf.text(
           (item.CGST > 0 ? (item.gstarte/2) : 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
          160,
          y,
          { align: "right" }
        );
        

         pdf.text(
          item.CGST.toLocaleString("en-IN", { minimumFractionDigits: 2 }),
          180,
          y,
          { align: "right" }
        );
        pdf.text(
          (item.CGST > 0 ? (item.gstarte/2) : 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
          200,
          y,
          { align: "right" }
        );
         pdf.text(
          item.SGST.toLocaleString("en-IN", { minimumFractionDigits: 2 }),
          220,
          y,
          { align: "right" }
        );
        pdf.text(
         (item.IGST > 0 ? item.gstarte : 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
          240,
          y,
          { align: "right" }
        );
        pdf.text(
          item.IGST.toLocaleString("en-IN", { minimumFractionDigits: 2 }),
          260,
          y,
          { align: "right" }
        );
        const totalamt = (parseFloat(item.Value)+parseFloat(item.CGST)+parseFloat(item.SGST)+parseFloat(item.IGST) || 0) ;
        pdf.text(
          totalamt.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
          280,
          y,
          { align: "right" }
        );

        y += 5;
      });

      pdf.line(10, y, 280, y);

      /* ================= SIDE BY SIDE SECTION ================= */

      const taxableAmt = parseFloat(header.Taxable_Amount) || 0;

const summaryY = rightY ;

rightY = summaryY + 5;
//pdf.line(10, rightY, 280, rightY);
      const totalInWords = ConvertNumberToWord(
        parseFloat(header.Bill_Amount)
      );

      pdf.text(`Taxable Amt:`, 100, y + 6);
      pdf.text(`${taxableAmt}.`, 130, y + 6);
     
      pdf.text(`CGST Amt:`, 150, y + 6);
      pdf.text(`${header.CGST_Amount}.`, 170, y + 6);

      pdf.text(`SGST Amt:`, 190, y + 6);
      pdf.text(`${header.SGST_Amount}.`, 210, y + 6);

      pdf.text(`IGST Amt:`, 230, y + 6);
      pdf.text(`${header.IGST_Amount}.`, 255, y + 6);

      pdf.setFont("Signika-Bold");
      pdf.setTextColor(41, 122, 14);
      //pdf.text("Total Amount:", 120, y + 9);
     // pdf.text(`₹ ${formattedTotal}`, amountX, y + 9, { align: "right" });
      pdf.text(`Bill Amount:`, 230, y + 13);
      pdf.text(`${header.Bill_Amount}.`, 255, y + 13);
      y += 5;
      pdf.setLineWidth(0.3);
      pdf.line(10, y + 9, 280, y + 9);

      pdf.setFont("Signika-Bold");
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(8);
      pdf.text("Terms & Conditions:", 12, y + 12);
      pdf.setFont("Signika-Regular");
      const notes = [
        "- If there is no insurance of the goods, after dispatch from the destination,",
        "   we are not responsible for non delivery, damage or any kind of loss.",
        "- Buyer must inspect and confirm quality & quantity of the goods before dispatch from godown.",
        "   Once loaded and truck leaves godown, Said all responsibilities will be transfer to buyers account.",
        "- Please send the full amount in our account through RTGS before despatch the goods.",
        "   If the amount is not received in our account, Interest of 24% P.A. will be charged to the buyer.",
        `- Subject to ${header.companyCity} jurisdiction.`
      ];
      notes.forEach((n, i) => pdf.text(n, 12, y + 13 + (i + 1) * 3));

      y += 15;
      leftY=y
     // pdf.text("Bank Details", 12, leftY);
      leftY += 5;

      pdf.setFont("Signika-Regular");

      [
        ["Bank Details:",""],
        ["Bank Name:", "Bank Of India"],
        ["Account No:", "44600783515"],
        ["IFSC Code:", "SBIN0061351"],
        ["Branch:", "MIDC CHINCHOLI (61351)"]
      ].forEach(([label, value]) => {
        pdf.text(label, 150, leftY);
        pdf.text(value, 170, leftY);
        pdf.setTextColor(0, 0, 0); // Dark Blue
        leftY += 5;
      });
      
      const signY = y - 1;
      pdf.setFont("Signika-Bold");
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);
      const forText = `For. ${String(displayCompanyName ?? "")}`;
      const textWidth = pdf.getTextWidth(forText);
      const rightMargin = 250;
      const forTextX = rightMargin - textWidth;

      pdf.text(forText, forTextX, signY);
      const signWidth = 240;
      const signHeight = signWidth / 5;

      y -= 20;

      pdf.addImage(signImg, "PNG", 220, y + 20, signWidth, signHeight);
      pdf.text("Authorised Signatory", 220, y + 37);

      const footerY = 252;
      const footerHeight = 37;
      const poweredByY = footerY + footerHeight + 3;

      if (shouldUseImage) {
        pdf.addImage(footerImg, "PNG", 0, footerY, 260, footerHeight);
      } else {
        pdf.addImage(footerImg1, "PNG", 0, footerY, 210, footerHeight);
      }

      pdf.setFont("Signika-Medium");
      pdf.setFontSize(7);
      pdf.setTextColor(0, 0, 0);
      pdf.text("Powered by: Sugarian.app", 12, poweredByY);

      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfPreview({
        url: pdfUrl,
        data: {
          ...header,
          sale_rate: rate,
          Doc_No: `AS${header?.year || ""}-${header?.Doc_No || ""}`,
          CompanyName: displayCompanyName
        }
      });
    };
  }




  const gstNo = sessionStorage.getItem("Company_GSTNO") || "";


  const jkGSTs = [
    "27AAECJ8332R1ZV",
    "27AEJPS9860D1Z0",
    "27ARCPS1606H1ZW",
    "27AAMFJ4182A1ZG",
  ];

  const isJK = jkGSTs.includes(gstNo.toUpperCase());

  let label = ''
  if (isJK) {
    label = "accounts_sale_bill_2"
  }
  else {
    label = "AgriSaleBill"
  }
  return (
    <div id="pdf-content">
      {pdfPreview && (
        <PdfPreview
          pdfData={pdfPreview.url}
          apiData={pdfPreview.data}
          label={label}
        />
      )}
      <PrintButton disabledFeild={disabledFeild} fetchData={fetchData} label={"Sale Bill Print"} />
    </div>
  );
};
export default AgriSaleBillReport;

